module.exports = __webpack_public_path__ + "img/Pot.29310f0b.svg";